<template>
<div ref="scrollContent" class="heatmap-report content padding_both_sides" @click="onHideSettingOption">
  <template v-if="applyData.meta.isSPA || applyData.meta.isABInOtherReport">
    <div>
      <h2>{{ $t('ab.title') }} <template v-if="!applyData.meta.isABInOtherReport && hasItems">{{ $t('common.list') }}</template></h2>
    </div>
  </template>
  <template v-else>
    <div v-if="hasItems && isExactMatchType">
      <h2>{{ $t('ab.title') }} {{ $t('common.list') }}</h2>
    </div>
  </template>

  <div class="content__body">
    <!-- loading -->
    <div class="content__loading" v-if="isLoading">
      <ui-loading-circle :applyBackground="true"/>
    </div>
    <template v-else>
      <template v-if="applyData.meta.isSPA">
        <template v-if="!applyData.meta.isABInOtherReport && hasItems">
          <ABtestList :applyData="applyData"
                      :abPageList="abList"/>
        </template>
        <template v-else-if="this.applyData.bLogin">
          <div class="box-layout content__no-list">
            <div class="text--wrap">
              <figure class="fig-sidebar"><i class="icon illust--ab-little-wave"></i></figure>
              <figure class="fig-logo"><i class="icon icon--logo-new"></i></figure>
              <strong style="font-size: 37px;">{{ $t('ab.text') }}</strong>
              <p class="slogan" v-html="$t('ab.spaAndLoginList.slogan')"></p>
              <div style="display: flex;">
                <i style="margin-top: 11px;" class="icon icon_login_block"></i>
                <p class="desc warn" v-html="$t('ab.spaAndLoginList.desc')"></p>
              </div>
            </div>
            <figure class="fig-sign"><i class="icon illust--ab-sign"></i></figure>
          </div>
        </template>
        <template v-else-if="!isExactMatchType">
          <div class="box-layout content__match-type">
            <strong>{{ $t('ab.exactOnly.title') }}</strong>
            <figure class="fig-icons">
              <i class="icon icon--return-green-size70"></i>
              <i class="icon icon--warning-red-size30"></i>
            </figure>
            <p class="slogan" v-html="$t('ab.exactOnly.slogan', {matchType: applyData.matchType})"></p>
            <div class="page-info">
              <p class="page-name">{{ applyData.pageName }}</p>
              <div class="page-url">
                <span class="match-type">{{ applyData.matchType | matchType }}</span>
                <p>{{ applyData.url }}</p>
              </div>
            </div>
            <ui-button primary iconName="icon--back-white-size16" :disabled="isShared" @click="onGotoApplyRegister" class="btn__register">
              <span class="btn-text">{{ $t('common.registerPage') }}</span>
            </ui-button>
          </div>
        </template>
        <template v-else>
          <div class="box-layout content__no-list">
            <div class="text--wrap">
              <figure class="fig-sidebar"><i class="icon illust--ab-little-wave"></i></figure>
              <figure class="fig-logo"><i class="icon icon--logo-new"></i></figure>
              <strong style="font-size: 37px;">{{ $t('ab.text') }}</strong>
              <p class="slogan" v-html="$t('ab.spaList.slogan')"></p>
              <p class="desc" v-html="$t('ab.spaList.desc')"></p>
            </div>
            <figure class="fig-sign"><i class="icon illust--ab-sign"></i></figure>

            <ui-button primary
                       size="large"
                       iconName="icon--plus-white"
                       :disabled="isAddDisabled"
                       @click="onGoToRegisterWritting"
                       class="btn__register">
              {{ $t('common.register') }}
            </ui-button>
          </div>
        </template>
      </template>
      <template v-else>
        <!-- AB 불가 : 매치타입 -->
        <div v-if="!isExactMatchType" class="box-layout content__match-type">
          <strong>{{ $t('ab.exactOnly.title') }}</strong>
          <figure class="fig-icons">
            <i class="icon icon--return-green-size70"></i>
            <i class="icon icon--warning-red-size30"></i>
          </figure>
          <p class="slogan" v-html="$t('ab.exactOnly.slogan', {matchType: applyData.matchType})"></p>
          <div class="page-info">
            <p class="page-name">{{ applyData.pageName }}</p>
            <div class="page-url">
              <span class="match-type">{{ applyData.matchType | matchType }}</span>
              <p>{{ applyData.url }}</p>
            </div>
          </div>
          <ui-button primary iconName="icon--back-white-size16" :disabled="isShared" @click="onGotoApplyRegister" class="btn__register">
            <span class="btn-text">{{ $t('common.registerPage') }}</span>
          </ui-button>
        </div>

        <template v-else-if="applyData.meta.isABInOtherReport">
          <div class="box-layout content__match-type sameUrl">
            <strong>{{ $t('ab.existABUrl.title') }}</strong>
            <figure class="fig-icons">
              <i class="icon icon--abtest"></i>
              <i class="icon icon--warning-red-size30"></i>
            </figure>
            <p class="slogan" v-html="$t('ab.existABUrl.slogan')"></p>
            <div class="page-info">
              <p class="page-name">{{ applyData.meta.isABInOtherReport.pageName }}</p>
              <div class="page-url">
                <span class="match-type">{{ applyData.meta.isABInOtherReport.matchType | matchType }}</span>
                <span><a>{{ applyData.meta.isABInOtherReport.url }}</a></span>
              </div>
            </div>
            <ui-button primary iconName="icon--link-white-size16" :disabled="isShared" @click="onGoToReport(applyData.meta.isABInOtherReport.id)" class="btn__register">
              <span class="btn-text">{{ $t('common.view') }}</span>
            </ui-button>
          </div>
        </template>

        <template v-else>
          <!-- no list : 등록 유도 -->
          <div v-if="!hasItems" class="box-layout content__no-list">
            <div class="text--wrap">
              <figure class="fig-sidebar"><i class="icon icon--sidebar-size48"></i></figure>
              <figure class="fig-logo"><i class="icon icon--logo-new"></i></figure>
              <strong>{{ $t('ab.title') }}</strong>
              <p class="slogan" v-html="$t('ab.noList.slogan')"></p>
              <p class="desc" v-html="$t('ab.noList.desc')"></p>
            </div>
            <figure class="fig-illust"><i class="icon illust--ab-nolist"></i></figure>

            <ui-button primary
                       size="large"
                       iconName="icon--plus-white"
                       :disabled="isAddDisabled"
                       @click="onGoToRegister"
                       class="btn__register">
              {{ $t('common.register') }}
            </ui-button>
          </div>

          <!-- AB page list-->
          <ABtestList v-else
                      :applyData="applyData"
                      :abPageList="abList"/>
        </template>
      </template>

    </template>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { getList } from '@/api/abtest'
import ABtestList from '@/components/report-ab/ABtestList'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'ABList',
  components: {
    ABtestList,
    UiLoadingCircle,
    UiButton
  },
  data () {
    return {
      isLoading: false,
      abPageList: []
    }
  },
  computed: {
    ...mapState([
      'applyData',
      'abList',
      'userData'
    ]),
    aid () {
      return this.$route.params.aid
    },
    routeParams () {
      return {
        aid: this.aid
      }
    },
    hasItems () {
      return this.abList && this.abList.length
    },
    isExactMatchType () {
      return this.applyData.matchType === 'exact'
    },
    isShared () {
      return this.applyData.meta.shared
    },
    isAddDisabled () {
      return this.userData.creditEmpty || (this.applyData.state === 'endByPvLimit' || this.applyData.state === 'endByAnalysisDate') || (this.applyData.meta.isSPA && this.applyData.bLogin)
    }
  },
  methods: {
    getABList () {
      this.isLoading = true

      getList(this.applyData._id)
        .then(data => {
          this.abList = data
          this.isLoading = false
        })
        .catch(err => {
          console.error(err)
          this.isLoading = false
        })
    },
    onHideSettingOption () {
      const settingOptionEl = document.querySelectorAll('.col__setting .setting__option--wrap')
      for (const item of settingOptionEl) {
        item.style.display = 'none'
      }
    },
    onGoToRegister () {
      if (this.isShared) return false
      this.$router.push({
        name: 'ab.option',
        params: this.routeParams
      })
    },
    onGoToRegisterWritting () {
      this.$router.push({
        name: 'ab.add.text',
        params: this.routeParams
      })
    },
    onGotoApplyRegister () {
      if (this.isShared) return false
      this.$router.push({
        name: 'page-add'
      })
    },
    onGoToReport (aid) {
      const to = this.$router.resolve({ name: 'heatmap-report', params: { aid: aid } })
      window.open(to.href + 'ab/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.content__body {
  min-width: 1170px;

  &.middle {
    transform: translateY(50%);
  }
}
.heatmap-report {
  overflow-y: auto;
  padding-bottom: 85px;
  position: relative;

  h2 {
    margin-top: 30px;
    font-size: 22px;
    font-weight: bold;
    color: #444444;
  }

  .box-layout {
    border-radius: 40px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;

    &.content__no-list {
      width: 800px;
      min-height: 450px;
      margin: 170px auto 0;
      box-sizing: border-box;
      position: relative;
      .text--wrap {
        position: absolute;
        top: 50%;
        left: 34px;
        transform: translateY(-50%);

        .fig-logo {
          margin-top: 15px;
        }
        strong {
          margin-top: 3px;
          display: block;
          font-size: 52px;
          font-weight: bold;
          line-height: 1;
          color: #555555;
        }
        .slogan {
          font-size: 20px;
          font-weight: bold;
          line-height: 1.4;
          color: #1199af;
          margin-top: 20px;
        }
        .desc {
          font-size: 14px;
          line-height: 1.5;
          color: #444444;
          margin-top: 15px;
          &.warn {
            color: #EC0047
          }
        }
        .warn--wrap {
          display: flex;
        }
      }
      .fig-illust {
        position: absolute;
        top: 50px;
        right: -20px;
      }
      .fig-sign {
        position: absolute;
        top: 120px;
        right: 35px;
      }
      .btn__register {
        position: absolute;
        right: 35px;
        bottom: 35px;
      }
    }

    &.content__match-type {
      width: 620px;
      min-height: 517px;
      margin: 78px auto 0;
      padding-top: 60px;
      padding-bottom: 40px;
      box-sizing: border-box;
      position: relative;
      text-align: center;

      &.sameUrl {
        padding-top: 60px;
        /deep/ .icon--warning-red-size30 {
          margin-bottom: 27.5px !important;
          margin-left: 5px !important;
        }

        button {
          min-width: 100px;
          text-align: center;
        }
      }

      &.spa {
        width: 540px;
        min-height: 400px;
        margin: 134px auto 0;

        .slogan {
          margin-top: 15px;
        }

        figure {
          margin-top: 50px;
        }

        /deep/ strong {
          line-height: 1.3;
        }
      }

      strong {
        font-size: 40px;
        font-weight: bold;
        line-height: 1;
        color: #555555;
      }
      .fig-icons {
        margin-top: 20px;
        .icon--warning-red-size30 {
          margin-bottom: 12px;
          margin-left: 12px;
        }
      }
      .slogan {
        font-size: 18px;
        font-weight: bold;
        line-height: 1.33;
        color: #1199af;
        margin-top: 28px;
        margin-left: 50px;
        margin-right: 50px;

        /deep/ span {
          text-transform: capitalize;
        }
      }
      .page-info {
        border-top: 1px solid #d8d8d8;
        margin-top: 24px;
        margin-left: 50px;
        margin-right: 50px;
        padding-top: 29px;
        .page-name {
          font-size: 16px;
          font-weight: 500;
          line-height: 1.31;
          color: #2f2f2f;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .page-url {
          margin-top: 14px;
          font-size: 13px;
          line-height: 1.31;
          color: #666666;
          vertical-align: text-bottom;
          display: inline-block;

          .match-type {
            display: inline-block;
            margin-right: 8px;
            font-size: 12px;
            font-weight: bold;
            line-height: 1.31;
            color: #ffffff;
            padding: 1px 5px;
            border-radius: 4px;
            background-color: #8d8d8d;
            float: left;
          }

          p {
            float: right;
          }

          span:not(.match-type) {
            display: table-cell;
          }

          a {
            vertical-align: text-bottom;
            max-width: 464px;
            @include textEllipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: break-all;
            white-space: inherit;
            max-height: 51px;
            line-height: 1.31;
            text-decoration: none;
          }
        }
      }
      .btn__register {
        margin-top: 51px;
      }
    }
  }
}
</style>
